import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import {
    UiContentWr,
    UiContentCol,
    UiColTitleWr,
    UiColTitle,
} from "../../../_uiComponents/common/UiPageElements";
import UiContentCard from "../../../../components/_uiComponents/cards/UiContentCard";
import {
    UiCol,
    UiRowContainer,
    UiSingleRow,
} from "../../../_uiComponents/grid-container/GridContainer";
import { campaignGetLatestCampaignRequest } from "../../../../_redux/_actions";
import { cardTypes } from "../../../../_redux/_constants";
import { UiSlider } from "../../../_uiComponents/common/UiSlider";
import {
    UiNextArrow,
    UiPrevArrow,
} from "../../../_uiComponents/common/UiSliderArrows";
import { UiContentColWithSlider } from "../../../_uiComponents/common/UiPageElements";
import { isMobile } from "react-device-detect";
import {
    LOCATION_FROM,
    routeLocationLocalStorage,
} from "../../../../_redux/_constants";

import {
    userTypes,
    participantJobRoleIds,
    participantTypeIds,
    isLcvJobRole,
} from "../../../../_redux/_constants";

import TlcDecHome from "../../../../styles/img/tlc/2025/december/campaign-slider.png";
import TpmSpinWinCampaign from "../../../../styles/img/custom/campaigns/2025/tpm-spin-win/campaign-banner.png";
import WinsDecCampaign from "../../../../styles/img/custom/winsday/winsday-campaign-slider.png";
import HighRollersCampaign from "../../../../styles/img/custom/campaigns/2025/lcv/high-rollers/campaign-banner.png";
import SalesManagerCampaign from "../../../../styles/img/custom/campaigns/2025/lcv/sales-manager-incentive/campaign-slider.png";
import EvhcFocusCampaign from "../../../../styles/img/custom/campaigns/2026/evhc-focus/campaigns-slider.png";
import ServiceStarsCampaign from "../../../../styles/img/custom/campaigns/2026/service-star-2026/campaign-slider.png";
import RenaultRewardsCampaign from "../../../../styles/img/custom/campaigns/2026/renault-rewards/campaigns-slider.png";
import CuttingEdge2026Campaign from "../../../../styles/img/custom/campaigns/2026/cutting-edge-2026/camapigns-slider.png";
import MotrioPaydaysCampaign from "../../../../styles/img/custom/campaigns/2026/motrio-paydays/campaigns-slider.png";
import MotrioRewardsCampaign from "../../../../styles/img/custom/campaigns/2026/motrio-rewards/campaign-slider.png";
import AlpineJanBanner from "../../../../styles/img/custom/campaigns/2026/alpine/campaign-carousel.png";
import CastrolLiquidGoldCampaign from "../../../../styles/img/custom/campaigns/2026/castrol-liquid-gold/campaign-carousel.png";
import OptimumFrictionCampaign from "../../../../styles/img/custom/campaigns/2026/optimum-friction/campaign-carousel.png";
// import CastrolLegendsCampaign from "../../../../styles/img/custom/campaigns/2026/castrol-legends/campaign-carousel.png";
// import ServiceStarsWinnersCarousel from "../../../../styles/img/custom/campaigns/2026/service-star-2026/winners/campaign-carousel.png";
import RemanIncentiveCampaign from "../../../../styles/img/custom/campaigns/2026/reman/campaigns-carousel.png";
import IcrGameOnCampaign from "../../../../styles/img/custom/campaigns/2026/icrm-game-on/campaign-carousel.png";
import EvhcFocusDoublePointsCampaign from "../../../../styles/img/custom/campaigns/2026/evhc-double-points/campaign-carousel.png";
import GraphiteGainsCampaign from "../../../../styles/img/custom/campaigns/2026/graphite-gains/campaign-carousel.png";
import SleighQ4Campaign from "../../../../styles/img/custom/campaigns/2026/sleigh-q4/campaign-carousel.png";

const getCurrentCampaignIdFromPath = (pathname) => {
    const match = pathname.match(
        /\/app\/campaigns\/(?:service-stars-winners\/)?(\d+)/,
    );
    return match ? match[1] : null;
};

export default function CurrentCampaigns() {
    const actionDispatch = useDispatch();
    let navigate = useNavigate();
    const location = useLocation();
    const currentCampaignId = getCurrentCampaignIdFromPath(location.pathname);

    const { latestAchievements, thingsToDo, auth } = useSelector((state) => {
        return {
            auth: state.auth,
        };
    });

    // const { campaign } = useSelector((state) => {
    //     return {
    //         campaign: state.campaign,
    //     };
    // });

    useEffect(function () {
        // actionDispatch(
        //     campaignGetLatestCampaignRequest({
        //         pageNumber: 1,
        //         pageSize: 20,
        //         type: 0,
        //     }),
        // );
    }, []);

    const tradePartsManagerCampaigns = [
        {
            id: 174,
            campaignId: "409",
            jobRole: "",
            campaignName: "Trade Parts Manager Reman Incentive",
            campaignType: "Team Incentive",
            description:
                "Take your Reman sales into Overdrive and earn £15 for every sale you make beyond target.",
            endDate: "2026-12-31T00:00:00",
            imageUrl: `${RemanIncentiveCampaign}`,
            incentiveType: "",
            isApproved: true,
            rating: 0,
            ratingCount: 0,
            startDate: "2026-01-01T00:00:00",
            status: 1,
        },
        {
            id: 75,
            campaignId: "377",
            jobRole: "",
            campaignName: "Motrio Paydays is now a Prize Draw",
            campaignType: "Team Incentive",
            description:
                "There’s an all new spin to Motrio Paydays. The Monthly Prize Draw has arrived!",
            endDate: "2026-12-31T00:00:00",
            imageUrl: `${MotrioPaydaysCampaign}`,
        },
        {
            id: 102,
            campaignId: "378",
            jobRole: "",
            campaignName: "Motrio Rewards",
            campaignType: "Team Incentive",
            description:
                "Earn More with Motrio Rewards! Trade Loyalty Club gives you Motrio Rewards 2026! As a valued customer, every purchase gives you more chances to earn TLC reward points.",
            endDate: "2026-12-31T00:00:00",
            imageUrl: `${MotrioRewardsCampaign}`,
        },
        {
            id: 73,
            campaignId: "376",
            jobRole: "",
            campaignName: "Renault Rewards",
            campaignType: "Team Incentive",
            description:
                "Trade Loyalty Club gives you Renault Rewards 2026! As a valued customer, every purchase gives you more chances to earn TLC reward points.",
            endDate: "2026-12-31T00:00:00",
            imageUrl: `${RenaultRewardsCampaign}`,
            incentiveType: "",
            isApproved: false,
            rating: 0,
            ratingCount: 0,
            startDate: "2026-01-01T00:00:00",
            status: 2,
        },
        {
            id: 74,
            campaignId: "375",
            jobRole: "",
            campaignName: "Trade Parts Incentive 2026",
            campaignType: "Team Incentive",
            description:
                "Trade Parts Incentive 2026: Sharper Focus. Bigger Rewards.",
            endDate: "2026-12-31T00:00:00",
            imageUrl: `${CuttingEdge2026Campaign}`,
            incentiveType: "",
            isApproved: true,
            rating: 0,
            ratingCount: 0,
            startDate: "2026-01-01T00:00:00",
            status: 1,
        },
        // {
        //     id: 55,
        //     campaignId: "126",
        //     campaignName: "Q4 Trade Parts Manager Incentive",
        //     campaignType: "Prize Draw",
        //     description:
        //         "This campaign is now closed and all rewards have been paid",
        //     endDate: "2024-08-31T00:00:00",
        //     imageUrl: `${TpmSpinWinCampaign}`,
        //     incentiveType: "",
        //     isApproved: false,
        //     rating: 0,
        //     ratingCount: 0,
        //     startDate: "2023-10-01T00:00:00",
        //     status: 2,
        //     closed: true,
        // },
        // {
        //     id: 51,
        //     campaignId: "367",
        //     campaignName: "Q4 Cutting Edge Incentive",
        //     campaignType: "Prize Draw",
        //     description:
        //         "This campaign is now closed and all rewards have been paid",
        //     endDate: "2024-08-31T00:00:00",
        //     imageUrl: `${CuttingEdgeQ4Home}`,
        //     incentiveType: "",
        //     isApproved: false,
        //     rating: 0,
        //     ratingCount: 0,
        //     startDate: "2023-10-01T00:00:00",
        //     status: 2,
        //     closed: true,
        // },
        // {
        //     id: 39,
        //     campaignId: "366",
        //     campaignName: "Q3 Cutting Edge Incentive",
        //     campaignType: "Prize Draw",
        //     description:
        //         "Got the Cutting Edge? Every targeted sale boosts your reward pot, with instant payouts as you hit target.",
        //     endDate: "2024-08-31T00:00:00",
        //     imageUrl: `${CuttingEdgeQ3Home}`,
        //     incentiveType: "",
        //     isApproved: false,
        //     rating: 0,
        //     ratingCount: 0,
        //     startDate: "2023-10-01T00:00:00",
        //     status: 2,
        // },
        // {
        //     id: 34,
        //     campaignId: "330",
        //     jobRole: "",
        //     campaignName: "Q3 Mechanical Parts Incentive",
        //     campaignType: "Incentive",
        //     description:
        //         "Top the leaderboard this Quarter and earn a staggering £450 with Mechanical Parts!",
        //     endDate: "2024-08-31T00:00:00",
        //     imageUrl: `${FullThrottleCamp}`,
        // },

        // {
        //     id: 32,
        //     campaignId: "278",
        //     jobRole: "",
        //     campaignName: "TLC Gold Rush",
        //     campaignType: "Incentive",
        //     description:
        //         "This campaign is now closed and all rewards have been paid' ",
        //     endDate: "2024-08-31T00:00:00",
        //     imageUrl: `${TradePartsTlc}`,
        //     closed: true,
        // },
        // {
        //     id: 31,
        //     campaignId: "314",
        //     jobRole: "Trade Parts Manager",
        //     campaignName: "Incentive 2025",
        //     campaignType: "Incentive",
        //     description:
        //         "This campaign is now closed and final rewards have been paid",
        //     endDate: "2024-08-31T00:00:00",
        //     imageUrl: `${TradePartsManagerImg}`,
        //     closed: true,
        // },
    ];

    const motrioPaydaysCampaign = {
        id: 75,
        campaignId: "377",
        jobRole: "",
        campaignName: "Motrio Paydays is now a Prize Draw",
        campaignType: "Team Incentive",
        description:
            "There’s an all new spin to Motrio Paydays. The Monthly Prize Draw has arrived!",
        endDate: "2026-12-31T00:00:00",
        imageUrl: `${MotrioPaydaysCampaign}`,
    };

    const motrioRewardsCampaignItem = {
        id: 102,
        campaignId: "378",
        jobRole: "",
        campaignName: "Motrio Rewards",
        campaignType: "Team Incentive",
        description:
            "Earn More with Motrio Rewards! Trade Loyalty Club gives you Motrio Rewards 2026! As a valued customer, every purchase gives you more chances to earn TLC reward points.",
        endDate: "2026-12-31T00:00:00",
        imageUrl: `${MotrioRewardsCampaign}`,
    };

    const tlcCustomerCampaigns = [
        ...(auth?.userProfileDetails?.isMotrioCustomer
            ? [
                  motrioRewardsCampaignItem,
                  {
                      id: 73,
                      campaignId: "376",
                      jobRole: "",
                      campaignName: "Renault Rewards",
                      campaignType: "Team Incentive",
                      description:
                          "Trade Loyalty Club gives you Renault Rewards 2026! As a valued customer, every purchase gives you more chances to earn TLC reward points.",
                      endDate: "2026-12-31T00:00:00",
                      imageUrl: `${RenaultRewardsCampaign}`,
                  },
              ]
            : [
                  {
                      id: 73,
                      campaignId: "376",
                      jobRole: "",
                      campaignName: "Renault Rewards",
                      campaignType: "Team Incentive",
                      description:
                          "Trade Loyalty Club gives you Renault Rewards 2026! As a valued customer, every purchase gives you more chances to earn TLC reward points.",
                      endDate: "2026-12-31T00:00:00",
                      imageUrl: `${RenaultRewardsCampaign}`,
                  },
                  ...(auth?.userProfileDetails?.isTlc2025Customer
                      ? [
                            // {
                            //     id: 76,
                            //     campaignId: "267",
                            //     jobRole: "",
                            //     campaignName:
                            //         "December Trade Loyalty Incentive",
                            //     campaignType: "Incentive",
                            //     description:
                            //         "Time to wrap up, finish 2025 strong and get rewarded!",
                            //     endDate: "2024-08-31T00:00:00",
                            //     imageUrl: `${TlcDecHome}`,
                            // },
                        ]
                      : []),
              ]),
        // ...(auth?.userProfileDetails?.isMotrioCustomer ? [motrioRewardsCampaignItem, motrioPaydaysCampaign] : []),
        // {
        //     id: 73,
        //     campaignId: "376",
        //     jobRole: "",
        //     campaignName: "Renault Rewards",
        //     campaignType: "Team Incentive",
        //     description:
        //         "Trade Loyalty Club gives you Renault Rewards 2026! As a valued customer, every purchase gives you more chances to earn TLC reward points.",
        //     endDate: "2026-12-31T00:00:00",
        //     imageUrl: `${RenaultRewardsCampaign}`,
        // },
        // {
        //     id: 76,
        //     campaignId: "267",
        //     jobRole: "",
        //     campaignName: "December Trade Loyalty Incentive",
        //     campaignType: "Incentive",
        //     description:
        //         "Time to wrap up, finish 2025 strong and get rewarded!",
        //     endDate: "2024-08-31T00:00:00",
        //     imageUrl: `${TlcDecHome}`,
        // },
        // {
        //     id: 66,
        //     campaignId: "265",
        //     jobRole: "",
        //     campaignName: "November Trade Loyalty Incentive",
        //     campaignType: "Incentive",
        //     description:
        //         "Bring some sparkle to your November with another fantastic helping of TLC rewards!",
        //     endDate: "2024-08-31T00:00:00",
        //     imageUrl: `${TlcNovHome}`,
        // },
        // {
        //     id: 65,
        //     campaignId: "288",
        //     jobRole: "",
        //     campaignName: "October Trade Loyalty Incentive",
        //     campaignType: "Incentive",
        //     description:
        //         "Warm October up with more great TLC rewards! The more you spend the more you can bank and enjoy.",
        //     endDate: "2024-08-31T00:00:00",
        //     imageUrl: `${TlcOctHome}`,
        // },
        // {
        //     id: 64,
        //     campaignId: "287",
        //     jobRole: "",
        //     campaignName: "September Trade Loyalty Incentive",
        //     campaignType: "Incentive",
        //     description:
        //         "Purchase qualifying Renault and Dacia Trade Parts today and see your September earnings grow at pace!",
        //     endDate: "2024-08-31T00:00:00",
        //     imageUrl: `${TlcGoldSept}`,
        // },
        // {
        //     id: 63,
        //     campaignId: "286",
        //     jobRole: "",
        //     campaignName: "August Trade Loyalty Incentive",
        //     campaignType: "Incentive",
        //     description:
        //         "How far will you go this August? Win with TLC and unlock hot summer rewards!",
        //     endDate: "2024-08-31T00:00:00",
        //     imageUrl: `${TlcGoldAugust}`,
        // },
        // {
        //     id: 22,
        //     campaignId: "285",
        //     jobRole: "",
        //     campaignName: "July Trade Loyalty Incentive",
        //     campaignType: "Incentive",
        //     description:
        //         "Supercharge your summer—turn every purchase into GoldRush rewards!",
        //     endDate: "2024-08-31T00:00:00",
        //     imageUrl: `${TlcGoldJuly}`,
        // },
        // {
        //     id: 21,
        //     campaignId: "284",
        //     jobRole: "",
        //     campaignName: "June Trade Loyalty Incentive",
        //     campaignType: "Incentive",
        //     description:
        //         "Turn every parts purchase into rewards this June – from dinner dates to gym gains with GoldRush!",
        //     endDate: "2024-08-31T00:00:00",
        //     imageUrl: `${TlcGoldJune}`,
        // },
        // {
        //     id: 20,
        //     campaignId: "283",
        //     jobRole: "",
        //     campaignName: "May Trade Loyalty Incentive",
        //     campaignType: "Incentive",
        //     description:
        //         "Will May be your first golden breakthrough—or the next big win in your unstoppable Trade Loyalty streak?",
        //     endDate: "2024-08-31T00:00:00",
        //     imageUrl: `${TlcGoldMay}`,
        // },
        // {
        //     id: 19,
        //     campaignId: "282",
        //     jobRole: "",
        //     campaignName: "April Trade Loyalty Incentive",
        //     campaignType: "Incentive",
        //     description:
        //         "The GoldRush continues! Don't miss your share of the Gold level money this April?",
        //     endDate: "2024-08-31T00:00:00",
        //     imageUrl: `${TlcGoldApril}`,
        // },
        // {
        //     id: 18,
        //     campaignId: "276",
        //     jobRole: "",
        //     campaignName: "March Trade Loyalty Incentive",
        //     campaignType: "Incentive",
        //     description:
        //         "The GoldRush continues! How much will you earn in March?",
        //     endDate: "2024-08-31T00:00:00",
        //     imageUrl: `${GoldRushMarch}`,
        // },
        // {
        //     id: 17,
        //     campaignId: "275",
        //     jobRole: "",
        //     campaignName: "February Trade Loyalty Incentive",
        //     campaignType: "Incentive",
        //     description:
        //         "Great news! The Goldrush incentive is rolling into February 2025!",
        //     endDate: "2024-08-31T00:00:00",
        //     imageUrl: `${GoldRushFeb}`,
        // },
        // {
        //     id: 16,
        //     campaignId: "268",
        //     jobRole: "",
        //     campaignName: "January Gold Rush Incentive ",
        //     campaignType: "Incentive",
        //     description:
        //         "Start 2025 strong, aim for the gold, and let every purchase count towards January rewards with Renault Parts.",
        //     endDate: "2024-08-31T00:00:00",
        //     imageUrl: `${GoldRushJan}`,
        // },
    ];

    // TLC_TRADE_REP campaigns - always show 376, 378, and 267
    const tlcTradeRepCampaigns = [
        {
            id: 102,
            campaignId: "378",
            jobRole: "",
            campaignName: "Motrio Rewards",
            campaignType: "Team Incentive",
            description:
                "Earn More with Motrio Rewards! Trade Loyalty Club gives you Motrio Rewards 2026! As a valued customer, every purchase gives you more chances to earn TLC reward points.",
            endDate: "2026-12-31T00:00:00",
            imageUrl: `${MotrioRewardsCampaign}`,
        },
        {
            id: 73,
            campaignId: "376",
            jobRole: "",
            campaignName: "Renault Rewards",
            campaignType: "Team Incentive",
            description:
                "Trade Loyalty Club gives you Renault Rewards 2026! As a valued customer, every purchase gives you more chances to earn TLC reward points.",
            endDate: "2026-12-31T00:00:00",
            imageUrl: `${RenaultRewardsCampaign}`,
        },
        // {
        //     id: 76,
        //     campaignId: "267",
        //     jobRole: "",
        //     campaignName: "December Trade Loyalty Incentive",
        //     campaignType: "Incentive",
        //     description:
        //         "Time to wrap up, finish 2025 strong and get rewarded!",
        //     endDate: "2024-08-31T00:00:00",
        //     imageUrl: `${TlcDecHome}`,
        // },
    ];

    // Trade Area Manager campaigns - always show both Renault Rewards and Motrio Rewards
    const tradeAreaManagerCampaigns = [
        {
            id: 73,
            campaignId: "376",
            jobRole: "",
            campaignName: "Renault Rewards",
            campaignType: "Team Incentive",
            description:
                "Trade Loyalty Club gives you Renault Rewards 2026! As a valued customer, every purchase gives you more chances to earn TLC reward points.",
            endDate: "2026-12-31T00:00:00",
            imageUrl: `${RenaultRewardsCampaign}`,
        },
        {
            id: 102,
            campaignId: "378",
            jobRole: "",
            campaignName: "Motrio Rewards",
            campaignType: "Team Incentive",
            description:
                "Earn More with Motrio Rewards! Trade Loyalty Club gives you Motrio Rewards 2026! As a valued customer, every purchase gives you more chances to earn TLC reward points.",
            endDate: "2026-12-31T00:00:00",
            imageUrl: `${MotrioRewardsCampaign}`,
        },
    ];

    const tlcManagerCampaigns = [
        ...(auth?.userProfileDetails?.isMotrioCustomer
            ? [
                  motrioRewardsCampaignItem,
                  {
                      id: 73,
                      campaignId: "376",
                      jobRole: "",
                      campaignName: "Renault Rewards",
                      campaignType: "Team Incentive",
                      description:
                          "Trade Loyalty Club gives you Renault Rewards 2026! As a valued customer, every purchase gives you more chances to earn TLC reward points.",
                      endDate: "2026-12-31T00:00:00",
                      imageUrl: `${RenaultRewardsCampaign}`,
                  },
              ]
            : [
                  {
                      id: 73,
                      campaignId: "376",
                      jobRole: "",
                      campaignName: "Renault Rewards",
                      campaignType: "Team Incentive",
                      description:
                          "Trade Loyalty Club gives you Renault Rewards 2026! As a valued customer, every purchase gives you more chances to earn TLC reward points.",
                      endDate: "2026-12-31T00:00:00",
                      imageUrl: `${RenaultRewardsCampaign}`,
                  },
                  {
                      campaignId: "378",
                      jobRole: "",
                      campaignName: "Motrio Rewards",
                      campaignType: "Team Incentive",
                      description:
                          "Earn More with Motrio Rewards! Trade Loyalty Club gives you Motrio Rewards 2026! As a valued customer, every purchase gives you more chances to earn TLC reward points.",
                      endDate: "2026-12-31T00:00:00",
                      imageUrl: `${MotrioRewardsCampaign}`,
                  },
                  ...(auth?.userProfileDetails?.isTlc2025Customer
                      ? [
                            {
                                id: 76,
                                campaignId: "267",
                                jobRole: "",
                                campaignName:
                                    "December Trade Loyalty Incentive",
                                campaignType: "Incentive",
                                description:
                                    "Time to wrap up, finish 2025 strong and get rewarded!",
                                endDate: "2024-08-31T00:00:00",
                                imageUrl: `${TlcDecHome}`,
                            },
                        ]
                      : []),
              ]),
        // {
        //     id: 73,
        //     campaignId: "376",
        //     jobRole: "",
        //     campaignName: "Renault Rewards",
        //     campaignType: "Team Incentive",
        //     description:
        //         "Trade Loyalty Club gives you Renault Rewards 2026! As a valued customer, every purchase gives you more chances to earn TLC reward points.",
        //     endDate: "2026-12-31T00:00:00",
        //     imageUrl: `${RenaultRewardsCampaign}`,
        // },
        // {
        //     id: 76,
        //     campaignId: "267",
        //     jobRole: "",
        //     campaignName: "December Trade Loyalty Incentive",
        //     campaignType: "Incentive",
        //     description:
        //         "Time to wrap up, finish 2025 strong and get rewarded!",
        //     endDate: "2024-08-31T00:00:00",
        //     imageUrl: `${TlcDecHome}`,
        // },
        // {
        //     id: 66,
        //     campaignId: "265",
        //     jobRole: "",
        //     campaignName: "November Trade Loyalty Incentive",
        //     campaignType: "Incentive",
        //     description:
        //         "Bring some sparkle to your November with another fantastic helping of TLC rewards!",
        //     endDate: "2024-08-31T00:00:00",
        //     imageUrl: `${TlcNovHome}`,
        // },
        // {
        //     id: 65,
        //     campaignId: "288",
        //     jobRole: "",
        //     campaignName: "October Trade Loyalty Incentive",
        //     campaignType: "Incentive",
        //     description:
        //         "Warm October up with more great TLC rewards! The more you spend the more you can bank and enjoy.",
        //     endDate: "2024-08-31T00:00:00",
        //     imageUrl: `${TlcOctHome}`,
        // },
        // {
        //     id: 64,
        //     campaignId: "287",
        //     jobRole: "",
        //     campaignName: "September Trade Loyalty Incentive",
        //     campaignType: "Incentive",
        //     description:
        //         "Purchase qualifying Renault and Dacia Trade Parts today and see your September earnings grow at pace!",
        //     endDate: "2024-08-31T00:00:00",
        //     imageUrl: `${TlcGoldSept}`,
        // },
        // {
        //     id: 63,
        //     campaignId: "286",
        //     jobRole: "",
        //     campaignName: "August Trade Loyalty Incentive",
        //     campaignType: "Incentive",
        //     description:
        //         "How far will you go this August? Win with TLC and unlock hot summer rewards!",
        //     endDate: "2024-08-31T00:00:00",
        //     imageUrl: `${TlcGoldAugust}`,
        // },
        // {
        //     id: 22,
        //     campaignId: "285",
        //     jobRole: "",
        //     campaignName: "July Trade Loyalty Incentive",
        //     campaignType: "Incentive",
        //     description:
        //         "Supercharge your summer—turn every purchase into GoldRush rewards!",
        //     endDate: "2024-08-31T00:00:00",
        //     imageUrl: `${TlcGoldJuly}`,
        // },
        // {
        //     id: 21,
        //     campaignId: "284",
        //     jobRole: "",
        //     campaignName: "June Trade Loyalty Incentive",
        //     campaignType: "Incentive",
        //     description:
        //         "Turn every parts purchase into rewards this June – from dinner dates to gym gains with GoldRush!",
        //     endDate: "2024-08-31T00:00:00",
        //     imageUrl: `${TlcGoldJune}`,
        // },
        // {
        //     id: 20,
        //     campaignId: "283",
        //     jobRole: "",
        //     campaignName: "May Trade Loyalty Incentive",
        //     campaignType: "Incentive",
        //     description:
        //         "Will May be your first golden breakthrough—or the next big win in your unstoppable Trade Loyalty streak?",
        //     endDate: "2024-08-31T00:00:00",
        //     imageUrl: `${TlcGoldMay}`,
        // },
        // {
        //     id: 19,
        //     campaignId: "282",
        //     jobRole: "",
        //     campaignName: "April Trade Loyalty Incentive",
        //     campaignType: "Incentive",
        //     description:
        //         "The GoldRush continues! Don't miss your share of the Gold level money this April?",
        //     endDate: "2024-08-31T00:00:00",
        //     imageUrl: `${TlcGoldApril}`,
        // },
        // {
        //     id: 18,
        //     campaignId: "276",
        //     jobRole: "",
        //     campaignName: "March Trade Loyalty Incentive",
        //     campaignType: "Incentive",
        //     description:
        //         "The GoldRush continues! How much will you earn in March?",
        //     endDate: "2024-08-31T00:00:00",
        //     imageUrl: `${GoldRushMarch}`,
        // },
        // {
        //     id: 17,
        //     campaignId: "275",
        //     jobRole: "",
        //     campaignName: "February Trade Loyalty Incentive",
        //     campaignType: "Incentive",
        //     description:
        //         "Great news! The Goldrush incentive is rolling into February 2025!",
        //     endDate: "2024-08-31T00:00:00",
        //     imageUrl: `${GoldRushFeb}`,
        // },
        // {
        //     id: 16,
        //     campaignId: "268",
        //     jobRole: "",
        //     campaignName: "January Gold Rush Incentive ",
        //     campaignType: "Incentive",
        //     description:
        //         "Start 2025 strong, aim for the gold, and let every purchase count towards January rewards with Renault Parts.",
        //     endDate: "2024-08-31T00:00:00",
        //     imageUrl: `${GoldRushJan}`,
        // },
    ];

    const campaignServices = [
        // {
        //     id: 271,
        //     campaignId: "373",
        //     jobRole: "",
        //     campaignName: "EVHC Focus 2026",
        //     campaignType: "Team Incentive",
        //     description:
        //         "Increase your focus on Brake Pad and Disc sales this week for double points towards a bigger payout!",
        //     endDate: "2026-12-31T00:00:00",
        //     imageUrl: `${EvhcFocusDoublePointsCampaign}`,
        //     incentiveType: "",
        //     isApproved: true,
        //     rating: 0,
        //     ratingCount: 0,
        //     startDate: "2026-01-01T00:00:00",
        //     status: 1,
        // },
        {
            id: 412,
            campaignId: "412",
            jobRole: "",
            campaignName: "3 is the Magic Number with Discs in October & November",
            campaignType: "Individual Incentive",
            description:
                "Turn every third team brake disc sale into winning scratchcards for each Service Advisor.",
            endDate: "2026-12-31T00:00:00",
            imageUrl: `${OptimumFrictionCampaign}`,
        },
        {
            id: 78,
            campaignId: "379",
            jobRole: "",
            campaignName: "Release the GOLD in Castrol 1L Bottles",
            campaignType: "Team Incentive",
            description:
                "Starting this April, Castrol are back with another great reward grabbing game.",
            endDate: "2026-12-31T00:00:00",
            imageUrl: `${CastrolLiquidGoldCampaign}`,
            incentiveType: "",
            isApproved: true,
            rating: 0,
            ratingCount: 0,
            startDate: "2026-01-01T00:00:00",
            status: 1,
        },
        {
            id: 71,
            campaignId: "373",
            jobRole: "",
            campaignName: "EVHC Focus",
            campaignType: "Team Incentive",
            description:
                "Same as 2025… but with a whole lot more to smile about.",
            endDate: "2026-12-31T00:00:00",
            imageUrl: `${EvhcFocusCampaign}`,
            incentiveType: "",
            isApproved: true,
            rating: 0,
            ratingCount: 0,
            startDate: "2026-01-01T00:00:00",
            status: 1,
        },
      
        // {
        //     id: 45,
        //     campaignId: "368",
        //     campaignName: "Q4 Service Advisor Wear & Tear Incentive",
        //     campaignType: "Prize Draw",
        //     description:
        //         "This campaign is now closed and all rewards have been paid'",
        //     endDate: "2024-08-31T00:00:00",
        //     imageUrl: `${Q3CampaignSlider}`,
        //     incentiveType: "",
        //     isApproved: false,
        //     rating: 0,
        //     ratingCount: 0,
        //     startDate: "2023-10-01T00:00:00",
        //     status: 2,
        //     closed: true,
        // },

        // {
        //     id: 30,
        //     campaignId: "125",
        //     jobRole: "",
        //     campaignName: "Castrol Winsdays",
        //     campaignType: "Incentive",
        //     description:
        //         "This campaign is now closed and all rewards have been paid",
        //     endDate: "2024-08-31T00:00:00",
        //     imageUrl: `${WinsDecCampaign}`,
        //     incentiveType: "Hit & Win",
        //     isApproved: true,
        //     rating: 0,
        //     ratingCount: 0,
        //     startDate: "2023-10-15T00:00:00",
        //     status: 1,
        //     closed: true,
        // },
    ];

    const campaigns = [
        // {
        //     id: 128,
        //     campaignId: "2026",
        //     // route: "campaigns/service-stars-winners-2026",
        //     campaignName: "Quarter 3 Winners Service Stars 2026",
        //     campaignType: "Team Incentive",
        //     description:
        //         "We’re delighted to celebrate the quarter 3 winners of Service Stars 2026.",
        //     endDate: "2026-12-31T00:00:00",
        //     imageUrl: ServiceStarsWinnersCarousel,
        // },
        {
            id: 174,
            campaignId: "409",
            jobRole: "",
            campaignName: "Trade Parts Manager Reman Incentive",
            campaignType: "Team Incentive",
            description:
                "Take your Reman sales into Overdrive and earn £15 for every sale you make beyond target.",
            endDate: "2026-12-31T00:00:00",
            imageUrl: `${RemanIncentiveCampaign}`,
            incentiveType: "",
            isApproved: true,
            rating: 0,
            ratingCount: 0,
            startDate: "2026-01-01T00:00:00",
            status: 1,
        },
        {
            id: 275,
            campaignId: "382",
            jobRole: "",
            campaignName: "Earn up to £400 with iCRM",
            campaignType: "Team Incentive",
            description:
                "Boost your year-on-year Opportunity Index growth percentage to unlock game changing rewards",
            endDate: "2026-12-31T00:00:00",
            imageUrl: `${IcrGameOnCampaign}`,
            incentiveType: "",
            isApproved: true,
            rating: 0,
            ratingCount: 0,
            startDate: "2026-01-01T00:00:00",
            status: 1,
        },
        // {
        //     id: 271,
        //     campaignId: "373",
        //     jobRole: "",
        //     campaignName: "EVHC Focus 2026",
        //     campaignType: "Team Incentive",
        //     description:
        //         "Increase your focus on Brake Pad and Disc sales this week for double points towards a bigger payout!",
        //     endDate: "2026-12-31T00:00:00",
        //     imageUrl: `${EvhcFocusDoublePointsCampaign}`,
        //     incentiveType: "",
        //     isApproved: true,
        //     rating: 0,
        //     ratingCount: 0,
        //     startDate: "2026-01-01T00:00:00",
        //     status: 1,
        // },
       
        {
            id: 412,
            campaignId: "412",
            jobRole: "",
            campaignName: "3 is the Magic Number with Discs in October & November",
            campaignType: "Individual Incentive",
            description:
                "Turn every third team brake disc sale into winning scratchcards for each Service Advisor.",
            endDate: "2026-12-31T00:00:00",
            imageUrl: `${OptimumFrictionCampaign}`,
        },
        {
            id: 78,
            campaignId: "379",
            jobRole: "",
            campaignName: "Release the GOLD in Castrol 1L Bottles",
            campaignType: "Team Incentive",
            description:
                "Starting this April, Castrol are back with another great reward grabbing game.",
            endDate: "2026-12-31T00:00:00",
            imageUrl: `${CastrolLiquidGoldCampaign}`,
        },
        // {
        //     id: 175,
        //     campaignId: "380",
        //     jobRole: "",
        //     campaignName: "Service Manager Legends Incentive",
        //     campaignType: "Team Incentive",
        //     description:
        //         "WINNERS ANNOUNCED!",
        //     endDate: "2026-12-31T00:00:00",
        //     imageUrl: `${CastrolLegendsCampaign}`,
        //     isActive: false,
        //     incentiveType: "",
        //     isApproved: true,
        //     rating: 0,
        //     ratingCount: 0,
        //     startDate: "2026-01-01T00:00:00",
        //     status: 1,
        // },
        {
            id: 75,
            campaignId: "377",
            jobRole: "",
            campaignName: "Motrio Paydays is now a Prize Draw",
            campaignType: "Team Incentive",
            description:
                "There’s an all new spin to Motrio Paydays. The Monthly Prize Draw has arrived!",
            endDate: "2026-12-31T00:00:00",
            imageUrl: `${MotrioPaydaysCampaign}`,
            incentiveType: "",
            isApproved: true,
            rating: 0,
            ratingCount: 0,
            startDate: "2026-01-01T00:00:00",
            status: 1,
        },
        {
            id: 102,
            campaignId: "378",
            jobRole: "",
            campaignName: "Motrio Rewards",
            campaignType: "Team Incentive",
            description:
                "Earn More with Motrio Rewards! Trade Loyalty Club gives you Motrio Rewards 2026! As a valued customer, every purchase gives you more chances to earn TLC reward points.",
            endDate: "2026-12-31T00:00:00",
            imageUrl: `${MotrioRewardsCampaign}`,
        },
        {
            id: 73,
            campaignId: "376",
            jobRole: "",
            campaignName: "Renault Rewards",
            campaignType: "Team Incentive",
            description:
                "Trade Loyalty Club gives you Renault Rewards 2026! As a valued customer, every purchase gives you more chances to earn TLC reward points.",
            endDate: "2026-12-31T00:00:00",
            imageUrl: `${RenaultRewardsCampaign}`,
            incentiveType: "",
            isApproved: true,
            rating: 0,
            ratingCount: 0,
            startDate: "2026-01-01T00:00:00",
            status: 1,
        },
        {
            id: 74,
            campaignId: "375",
            jobRole: "",
            campaignName: "Trade Parts Incentive 2026",
            campaignType: "Team Incentive",
            description:
                "Trade Parts Incentive 2026: Sharper Focus. Bigger Rewards.",
            endDate: "2026-12-31T00:00:00",
            imageUrl: `${CuttingEdge2026Campaign}`,
            incentiveType: "",
            isApproved: true,
            rating: 0,
            ratingCount: 0,
            startDate: "2026-01-01T00:00:00",
            status: 1,
        },
        {
            id: 72,
            campaignId: "374",
            jobRole: "",
            campaignName: "Service Stars 2026",
            campaignType: "Team Incentive",
            description:
                "Rewarding the best Service Managers in each Area. Earn up to £400 points every quarter with Renault Service Stars in 2026!",
            endDate: "2026-12-31T00:00:00",
            imageUrl: `${ServiceStarsCampaign}`,
            incentiveType: "",
            isApproved: true,
            rating: 0,
            ratingCount: 0,
            startDate: "2026-01-01T00:00:00",
            status: 1,
        },
        {
            id: 71,
            campaignId: "373",
            jobRole: "",
            campaignName: "EVHC Focus",
            campaignType: "Team Incentive",
            description:
                "Same as 2025… but with a whole lot more to smile about.",
            endDate: "2026-12-31T00:00:00",
            imageUrl: `${EvhcFocusCampaign}`,
            incentiveType: "",
            isApproved: true,
            rating: 0,
            ratingCount: 0,
            startDate: "2026-01-01T00:00:00",
            status: 1,
        },
        // {
        //     id: 69,
        //     campaignId: "372",
        //     jobRole: "",
        //     campaignName: "Finish the year on a charge!",
        //     campaignType: "Incentive",
        //     description:
        //         "This December, earn £5 on every Battery sold over target. Only the first 200 count",
        //     endDate: "2024-08-31T00:00:00",
        //     imageUrl: `${BatteriesCampaign}`,
        //     incentiveType: "Hit & Win",
        //     isApproved: true,
        //     rating: 0,
        //     ratingCount: 0,
        //     startDate: "2023-10-15T00:00:00",
        //     status: 1,
        // },
        // {
        //     id: 55,
        //     campaignId: "126",
        //     campaignName: "Q4 Trade Parts Manager Incentive",
        //     campaignType: "Prize Draw",
        //     description:
        //         "This campaign is now closed and all rewards have been paid",
        //     endDate: "2024-08-31T00:00:00",
        //     imageUrl: `${TpmSpinWinCampaign}`,
        //     incentiveType: "",
        //     isApproved: false,
        //     rating: 0,
        //     ratingCount: 0,
        //     startDate: "2023-10-01T00:00:00",
        //     status: 2,
        //     closed: true,
        // },
        // {
        //     id: 29,
        //     campaignId: "370",
        //     jobRole: "",
        //     campaignName: "Earn BIG on Brake Pads",
        //     campaignType: "Incentive",
        //     description:
        //         "This October, earn £5 for every Brake Pad sold over target. Only the first 200 national sales count",
        //     endDate: "2024-08-31T00:00:00",
        //     imageUrl: `${BrakePadsCampaign}`,
        //     incentiveType: "Hit & Win",
        //     isApproved: true,
        //     rating: 0,
        //     ratingCount: 0,
        //     startDate: "2023-10-15T00:00:00",
        //     status: 1,
        // },
        // {
        //     id: 70,
        //     campaignId: "371",
        //     jobRole: "",
        //     campaignName: "Focus On Wipers",
        //     campaignType: "Incentive",
        //     description:
        //         "This November, earn £5 for every Wiper set sold over target. National rewards limited to the first 200 qualifying sales.",
        //     endDate: "2024-08-31T00:00:00",
        //     imageUrl: `${WipersCampaign}`,
        //     incentiveType: "Hit & Win",
        //     isApproved: true,
        //     rating: 0,
        //     ratingCount: 0,
        //     startDate: "2023-10-15T00:00:00",
        //     status: 1,
        // },
        // {
        //     id: 28,
        //     campaignId: "128",
        //     jobRole: "",
        //     campaignName: "Service Stars 2025",
        //     campaignType: "Incentive",
        //     description:
        //         "WINNERS ANNOUNCED - find out who made the best of the best winners list!",
        //     endDate: "2024-08-31T00:00:00",
        //     imageUrl: `${ServiceStarsCampBanner}`,
        //     incentiveType: "Hit & Win",
        //     isApproved: true,
        //     rating: 0,
        //     ratingCount: 0,
        //     startDate: "2023-10-15T00:00:00",
        //     status: 1,
        // },
        // {
        //     id: 30,
        //     campaignId: "125",
        //     jobRole: "",
        //     campaignName: "Castrol WINsdays",
        //     campaignType: "Incentive",
        //     description:
        //         "This campaign is now closed and all rewards have been paid",
        //     endDate: "2024-08-31T00:00:00",
        //     imageUrl: `${WinsDecCampaign}`,
        //     incentiveType: "Hit & Win",
        //     isApproved: true,
        //     rating: 0,
        //     ratingCount: 0,
        //     startDate: "2023-10-15T00:00:00",
        //     status: 1,
        //     closed: true,
        // },
        // {
        //     id: 45,
        //     campaignId: "368",
        //     campaignName: "Q4 Service Advisor Wear & Tear Incentive",
        //     campaignType: "Prize Draw",
        //     description:
        //         "This campaign is now closed and all rewards have been paid'",
        //     endDate: "2024-08-31T00:00:00",
        //     imageUrl: `${Q3CampaignSlider}`,
        //     incentiveType: "",
        //     isApproved: false,
        //     rating: 0,
        //     ratingCount: 0,
        //     startDate: "2023-10-01T00:00:00",
        //     status: 2,
        //     closed: true,
        // },
        // {
        //     id: 29,
        //     campaignId: "365",
        //     jobRole: "",
        //     campaignName: "Castrol's FAB 500 is back",
        //     campaignType: "Incentive",
        //     description:
        //         "This campaign is now closed and all rewards have been paid",
        //     endDate: "2024-08-31T00:00:00",
        //     imageUrl: `${CastrolSepHome}`,
        //     incentiveType: "Hit & Win",
        //     isApproved: true,
        //     rating: 0,
        //     ratingCount: 0,
        //     startDate: "2023-10-15T00:00:00",
        //     status: 1,
        //     closed: true,
        // },
        // {
        //     id: 69,
        //     campaignId: "369",
        //     jobRole: "",
        //     campaignName: "August's Golden Tickets",
        //     campaignType: "Incentive",
        //     description:
        //         "This campaign is now closed and rewards have been paid",
        //     endDate: "2024-08-31T00:00:00",
        //     imageUrl: `${MayGoldTicket}`,
        //     incentiveType: "Hit & Win",
        //     isApproved: true,
        //     rating: 0,
        //     ratingCount: 0,
        //     startDate: "2023-10-15T00:00:00",
        //     status: 1,
        //     closed: true,
        // },
        // {
        //     id: 51,
        //     campaignId: "367",
        //     jobRole: "",
        //     campaignName: "Q4 Cutting Edge Incentive",
        //     campaignType: "Incentive",
        //     description:
        //         "This campaign is now closed and all rewards have been paid",
        //     endDate: "2024-08-31T00:00:00",
        //     imageUrl: `${CuttingEdgeQ4Home}`,
        //     closed: true,
        // },

        // {
        //     id: 28,
        //     campaignId: "366",
        //     jobRole: "",
        //     campaignName: "Q3 Cutting Edge Incentive",
        //     campaignType: "Incentive",
        //     description:
        //         "This campaign is now closed and rewards have been paid",
        //     endDate: "2024-08-31T00:00:00",
        //     imageUrl: `${CuttingEdgeCampaign}`,
        //     closed: true,
        // },

        // {
        //     id: 43,
        //     campaignId: "330",
        //     jobRole: "",
        //     campaignName: "Q3 Mechanical Parts Incentive",
        //     campaignType: "Incentive",
        //     description:
        //         "This campaign is now closed and rewards have been paid",
        //     endDate: "2024-08-31T00:00:00",
        //     imageUrl: `${FullThrottleCamp}`,
        //     incentiveType: "Hit & Win",
        //     isApproved: true,
        //     rating: 0,
        //     ratingCount: 0,
        //     startDate: "2023-10-15T00:00:00",
        //     status: 1,
        //     closed: true,
        // },

        // {
        //     id: 32,
        //     campaignId: "316",
        //     jobRole: "",
        //     campaignName: "Castrol MotoGP Incentive",
        //     campaignType: "Incentive",
        //     description:
        //         "This campaign is now closed and winners have been notified",
        //     endDate: "2024-08-31T00:00:00",
        //     imageUrl: `${CastrolMotoGp}`,
        //     closed: true,
        // },

        // {
        //     id: 32,
        //     campaignId: "278",
        //     jobRole: "",
        //     campaignName: "TLC Gold Rush",
        //     campaignType: "Incentive",
        //     description:
        //         "This campaign is now closed and all rewards have been paid' ",
        //     endDate: "2024-08-31T00:00:00",
        //     imageUrl: `${TradePartsTlc}`,
        //     closed: true,
        // },
        // {
        //     id: 31,
        //     campaignId: "314",
        //     jobRole: "Trade Parts Manager",
        //     campaignName: "Incentive 2025",
        //     campaignType: "Incentive",
        //     description:
        //         "This campaign is now closed and final rewards have been paid",
        //     endDate: "2024-08-31T00:00:00",
        //     imageUrl: `${TradePartsManagerImg}`,
        //     closed: true,
        // },
    ];

    const lcvManagerCampaigns = [
        // {
        //     id: 360,
        //     campaignId: "125",
        //     campaignName: "Q1, LCV Sales Incentive",
        //     campaignType: "Prize Draw",
        //     description:
        //         "Claim your place among the High Rollers and earn guaranteed prizes every day",
        //     endDate: "2024-08-31T00:00:00",
        //     imageUrl: HighRollersCampaign,
        //     incentiveType: "",
        //     isApproved: false,
        //     rating: 0,
        //     ratingCount: 0,
        //     startDate: "2023-10-01T00:00:00",
        //     status: 2,
        // },
        {
            id: 413,
            campaignId: 413,
            campaignName: "Your van sales could earn you \u00A31,000",
            campaignType: "Prize Draw",
            description:
                "Every 3 eligible LCV registrations you make will earn you a spin of the reward wheel",
            endDate: "2026-12-11T23:59:59",
            imageUrl: SleighQ4Campaign,
            incentiveType: "",
            isApproved: false,
            rating: 0,
            ratingCount: 0,
            startDate: "2026-10-05T00:00:00",
            status: 2,
        },
        {
            id: 369,
            campaignId: 410,
            campaignName: "Q3, Sales Team LCV Sales Incentive",
            campaignType: "Prize Draw",
            description:
                "Earn a prize spin with every three Trafic Graphite Edition sales during Q3. ",
            endDate: "2024-08-31T00:00:00",
            imageUrl: GraphiteGainsCampaign,    
            incentiveType: "",
            isApproved: false,
            rating: 0,
            ratingCount: 0,
            startDate: "2023-10-01T00:00:00",
            status: 2,
        },
        // {
        //     id: 359,
        //     campaignId: "127",
        //     campaignName: "LCV Manager Travel Incentive",
        //     campaignType: "Prize Draw",
        //     description:
        //         "Hit the top of your league to secure your place on this year’s trip of a lifetime",
        //     endDate: "2024-08-31T00:00:00",
        //     imageUrl: SalesManagerCampaign,
        //     incentiveType: "",
        //     isApproved: false,
        //     rating: 0,
        //     ratingCount: 0,
        //     startDate: "2023-10-01T00:00:00",
        //     status: 2,
        // },
    ];

    const UiCampaignSliderMobile = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        nextArrow: <UiNextArrow />,
        prevArrow: <UiPrevArrow />,
    };

    const UiCampaignSlider = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        nextArrow: <UiNextArrow />,
        prevArrow: <UiPrevArrow />,
    };

    const readMore = (id, type) => {
        window.scrollTo({ top: 0, left: 0, behavior: "instant" });
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;

        if (type == "Quiz") {
            localStorage.setItem(
                LOCATION_FROM,
                routeLocationLocalStorage.CAMPAIGN,
            );
            navigate("/app/learn/" + id);
        } else if (type == "Comms") {
            navigate("/app/campaigns/comms/" + id);
        }
        // else if (id == 2026) {
        //     navigate("/app/campaigns/service-stars-winners/2026");
        // }
        else {
            navigate("/app/campaigns/" + id);
        }
    };

    const AlpineCampaigns = [
        {
            id: 39,
            campaignId: "131",
            campaignName:
                "Service Manager Incentive : Alpine Customer Excellence",
            campaignType: "Prize Draw",
            description:
                "Earn 3,000 Équipe points (£30) for every 5-star rating you receive from an Alpine aftersales customer!",
            endDate: "2024-08-31T00:00:00",
            imageUrl: AlpineJanBanner,
            incentiveType: "",
            isApproved: false,
            rating: 0,
            ratingCount: 0,
            startDate: "2023-10-01T00:00:00",
            status: 2,
        },
        // {
        //     id: 29,
        //     campaignId: "130",
        //     campaignName:
        //         "Service Manager Incentive : Alpine Customer Excellence",
        //     campaignType: "Prize Draw",
        //     description:
        //         "Earn 3,000 Équipe points (£30) for every 5-star rating you receive from an Alpine aftersales customer!",
        //     endDate: "2024-08-31T00:00:00",
        //     imageUrl: AlpineCustomer,
        //     incentiveType: "",
        //     isApproved: false,
        //     rating: 0,
        //     ratingCount: 0,
        //     startDate: "2023-10-01T00:00:00",
        //     status: 2,
        // },
    ];

    const AreaManagerCampaignId = [
        "412",
        // "2026",
        "382",
        "379",
        // "380",
        "300",
        "290",
        "270",
        "260",
        "280",
        // "125",
        // "128",
        "325",
        // "130",
        "131",
        "313",
        // "278",
        // "314",
        "316",
        "315",
        "318",
        // "130",
        "131",
        // "330",
        // "366",
        // "367",
        // "365",
        // "368",
        "370",
        // "372",
        "371",
        "373",
        "374",
        // "409"
        
        // "375", // Cutting Edge - Trade & customer campaign
        // "376", // Renault Rewards - Trade & customer campaign
        // "377", // Motrio Pay Day - Trade & customer campaign
        // "378", // Motrio Rewards - Trade & customer campaign
        // "267", // December Goldrush - Trade & customer campaign
        // "126",
    ];
    const SuperAreaManagerCampaignId = [
        "412",
        // "2026",
        "379",
        "382",
        // "380",
        "300",
        "290",
        "270",
        "260",
        "280",
        // "125",
        // "128",
        // "130",
        "131",
        "313",
        // "278",
        "314",
        "315",
        "316",
        "318",
        "330",
        "360",
        "366",
        // "365",
        // "368",
        "369",
        // "367",
        "370",
        // "372",
        "371",
        // "126",
        "373",
        "374",
        "376",
        "375",
        "377",
        "378",
        "409",
        
    ];
    const ServiceManagerHideCampaignId = [
        // "278",
       
        "314",
        "330",
        "366",
        // "367",
        "375",
        "376",
        "377",
        "378",
        "409",
        
    ];
    const visibleUserId = [
        2000038, 2000110, 2000152, 2000599, 2000319, 2000085, 2000382, 2000164,
        2000104, 2000069, 2000035, 2000034, 1000001, 2000588, 2000670, 2000669,
    ];
    const visibleAlpineUsers = [
        2000034, 2000381, 2000382, 2000383, 2000384, 2000385, 2000404, 2000673, 2000674, 
        2002124, 2000071, 2001706, 2001726, 2000928, 2000223, 2000671, 2013862, 2000112, 
        2000647, 2000178, 2000105, 2000109, 1000001, 2000035, 2000038, 2000588, 2000593, 
        2000610, 2000789, 2000816, 2001078, 2001083, 2002127, 2013853, 2013925
    ];

    const displayCampaign = (jobRoleId, userId) => {
        if (
            jobRoleId ===
                participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SERVICE_ADVISOR &&
            auth?.userProfileDetails.roleId == participantTypeIds.PARTICIPANT
        ) {
            // if (visibleAlpineUsers.includes(userId)) {
            //     campaignServices.splice(2, 0, ...AlpineCampaigns);
            // }
            return campaignServices;
        }
        if (
            jobRoleId ===
                participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SERVICE_MANAGER &&
            auth?.userProfileDetails.roleId == participantTypeIds.PARTICIPANT
        ) {
            if (visibleAlpineUsers.includes(userId)) {
                campaigns.splice(4, 0, ...AlpineCampaigns);
            }
            return campaigns.filter(
                (campaigns) =>
                    !ServiceManagerHideCampaignId.includes(
                        campaigns.campaignId,
                    ) && campaigns.campaignId !== "126",
            );
        }
        if (
            jobRoleId ===
                participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SERVICE_AREA_MANAGER &&
            auth?.userProfileDetails.roleId == participantTypeIds.PARTICIPANT &&
            auth?.userProfileDetails?.area !== "0"
        ) {
            if (visibleAlpineUsers.includes(userId)) {
                campaigns.splice(4, 0, ...AlpineCampaigns);
            }
            return campaigns.filter((campaign) =>
                AreaManagerCampaignId.includes(campaign.campaignId),
            );
        }

        if (
            jobRoleId ===
            participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_NATIONAL_MANAGER
        ) {
            if (visibleAlpineUsers.includes(userId)) {
                campaigns.splice(4, 0, ...AlpineCampaigns);
            }
            // The LCV cards live in their own list because the LCV roles get that list instead of
            // this one. A National Manager reads the whole network, so he gets both, appended
            // rather than filtered: the LCV cards carry a numeric campaignId and would never match
            // the string ids in SuperAreaManagerCampaignId.
            return [
                ...campaigns.filter((campaign) =>
                    SuperAreaManagerCampaignId.includes(campaign.campaignId),
                ),
                ...lcvManagerCampaigns,
            ];
        }

        if (
            jobRoleId === participantJobRoleIds.TLC_PARTICIPANT_AREA_MANAGER &&
            auth?.userProfileDetails.roleId ==
                participantTypeIds.TLC_PARTICIPANT
        ) {
            return tlcManagerCampaigns;
        }
        if (jobRoleId === participantJobRoleIds.TLC_TRADE_REP) {
            // A trade rep on Equipe also views the three trade campaigns. A TLC trade rep does not.
            if (auth?.userProfileDetails?.roleId == participantTypeIds.PARTICIPANT) {
                const tradeCampaignIds = ["375", "377", "409"];
                return [
                    ...tlcTradeRepCampaigns,
                    ...campaigns.filter((campaign) =>
                        tradeCampaignIds.includes(campaign.campaignId),
                    ),
                ];
            }
            return tlcTradeRepCampaigns;
        }

        if (
            jobRoleId === participantJobRoleIds.TLC_PARTICIPANT_CUSTOMER &&
            auth?.userProfileDetails.roleId ==
                participantTypeIds.TLC_PARTICIPANT
        ) {
            return tlcCustomerCampaigns;
        }

        if (
            jobRoleId ===
                participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_TRADE_PARTS_MANAGER &&
            auth?.userProfileDetails.roleId == participantTypeIds.PARTICIPANT
        ) {
            return tradePartsManagerCampaigns;
        }

        if (
            isLcvJobRole(jobRoleId) &&
            auth?.userProfileDetails.roleId == participantTypeIds.PARTICIPANT
        ) {
            return lcvManagerCampaigns;
        }

        return [];
    };
    

    return (
        <>
            <UiContentWr>
                <UiRowContainer fluid="fluid">
                    <UiCol lg="12" xl="12">
                        <UiContentColWithSlider>
                            <UiColTitleWr id="Lastest-campaigns">
                                <UiColTitle title="Campaigns " />
                            </UiColTitleWr>

                            <div className="sb-campaigns-slider sb-latest-campaign-slider">
                                <UiSlider
                                    UiSliderSettings={
                                        isMobile
                                            ? UiCampaignSliderMobile
                                            : UiCampaignSlider
                                    }
                                >
                                    {auth?.userProfileDetails.jobRoleId &&
                                        displayCampaign(
                                            auth?.userProfileDetails?.jobRoleId,
                                            auth?.userProfileDetails?.userId,
                                        )
                                            .filter(
                                                (campaign) =>
                                                    String(campaign.campaignId) !==
                                                    currentCampaignId,
                                            )
                                            .map((campaign, id) => (
                                            <div
                                                key={id}
                                                onClick={() =>
                                                    campaign.isActive !== false &&
                                                    readMore(
                                                        campaign.campaignId,
                                                        campaign.campaignType,
                                                    )
                                                }
                                            >
                                                <UiRowContainer>
                                                    <UiCol lg="12">
                                                        <UiContentCard
                                                            key={id}
                                                            campaignClosed={
                                                                campaign.isActive === false
                                                            }
                                                            cardImg={
                                                                campaign.imageUrl
                                                            }
                                                            heading={
                                                                campaign.campaignName
                                                            }
                                                            jobRole={
                                                                campaign.jobRole
                                                            }
                                                            latestCampaign
                                                            body={
                                                                campaign.description
                                                            }
                                                            // readMore={() =>
                                                            //     readMore(
                                                            //         campaign.campaignId,
                                                            //         campaign.campaignType,
                                                            //     )
                                                            // }
                                                            type={
                                                                cardTypes.CAMPAIGN
                                                            }
                                                            // points={campaign.rating}
                                                        />
                                                    </UiCol>
                                                </UiRowContainer>
                                            </div>
                                        ))}
                                </UiSlider>
                                {campaigns.length > 3 && (
                                    <div className="sb-campaigns-slider__fade-out"></div>
                                )}
                            </div>
                        </UiContentColWithSlider>
                    </UiCol>
                </UiRowContainer>
            </UiContentWr>
        </>
    );
}
